import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TenderService } from 'src/app/core/services/tender.service';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';
import { ActivatedRoute } from '@angular/router';
import { listType } from "../../../core/enumerations/enum-ListType";
import { payRequestModel } from 'src/app/core/models/payRequestModel';
import { PaginationModel } from 'src/app/core/models/pagination-model';
import { PublicPortalService } from "../../../core/services/public-portal/public-portal.service";

@Component({
  selector: 'app-tender-details',
  templateUrl: './tender-details.component.html',
  styleUrls: ['./tender-details.component.scss']
})
export class TenderDetailsComponent implements OnInit {
  payRequestModel: payRequestModel;
  paginationModel: PaginationModel;

  tenderData: any = null; // Holds tender data
  noData: boolean = false; // Flag for missing data
  currentDate: Date = new Date();

  constructor(private route: ActivatedRoute, private service: PublicPortalService,
    public userUtilsService: UserUtilService,
    private router: Router, private tenderService: TenderService) { }

  ngOnInit(): void {
    debugger
    this.payRequestModel = new payRequestModel();
    this.paginationModel = new PaginationModel();


    this.tenderData = this.tenderService.getTenderData();
    this.route.queryParams.subscribe(params => {
      debugger
      const itemId = params['tender_no'];
      if(itemId != undefined)
      {
      this.getTender(itemId);
      }
      else if(this.tenderData.isHistory==true && this.tenderData!=null)
      {
        this.getTender(this.tenderData.item_id);
      }
    });
  


    // this.tenderData = this.tenderService.getTenderData();


    if (!this.tenderData) {
      this.noData = true;
    }
  }


  getTender(tender_id) {
    debugger
    if(this.tenderData!=null || this.tenderData!=undefined){
    this.payRequestModel.Type = this.tenderData.isHistory==true? listType.TendersHistory: listType.ActiveTenders;}
    else{
      this.payRequestModel.Type =  listType.ActiveTenders;
    }
    this.payRequestModel.ID = 0;

    this.payRequestModel.City = null
    this.payRequestModel.TenderNumber = tender_id;
    this.payRequestModel.TenderWorth = null;

    this.payRequestModel.Sector = null


    this.payRequestModel.Organization = null



    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize = "10"


    this.service.GetPayDetailList(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any);
              this.tenderData = data?.records[0]

            }
          }
        }
      }
      )
    //}
  }

  goBack() {
    this.router.navigate(['/tender']); // Navigate back
  }

  printInvoice() {
    const invoice = document.getElementById('invoiceSection');
    const printTime = new Date().toLocaleString();
    const printUrl = window.location.href;

    // Fill the placeholders
    const timeElem = document.getElementById('printTime');
    const urlElem = document.getElementById('printUrl');

    if (timeElem && urlElem) {
      timeElem.innerText = `${printTime}`;
      urlElem.innerText = `${printUrl}`;
    }

    const originalContents = document.body.innerHTML;

    if (invoice) {
      document.body.innerHTML = invoice.innerHTML;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // optional: reloads Angular app state
    }
  }
}
